import { hasDefinedValue } from '@sgme/fp';
import { TagOption } from 'components/shared/Tags/model';
import { Underlying } from 'models/underlying';
import { useMemo } from 'react';

type Options = { underlyings: readonly Underlying[]; tags: readonly TagOption<Underlying>[] };
export function useUnderlyingsBasket({ underlyings, tags }: Options) {
  const selectedUnderlyings = useMemo(() => {
    return underlyings.length > 0 ? underlyings : tags.filter(hasDefinedValue('rawValue')).map(tag => tag.rawValue);
  }, [underlyings, tags]);
  const selectedUnderlyingsIds = useMemo(() => {
    return selectedUnderlyings.map(({ id }: Underlying) => id);
  }, [selectedUnderlyings]);
  return { selectedUnderlyings: selectedUnderlyings, selectedUnderlyingsIds: selectedUnderlyingsIds };
}
